// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.white-label {
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
}
.white-label .payment {
  /* width: 250px; */
  /* height: 40px; */
}

.widget {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 60px;
  height: 60px;
  object-fit: contain;
  z-index: 99;
  border-radius: 100%;
}
.cursor-pointer {
  cursor: pointer;
}

/* Ant design */

.ant-modal-mask {
  background: rgba(237, 237, 237, 0.5) !important;
  backdrop-filter: blur(20.299999237060547px) !important;
}
.card-input {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.card-label {
  color: #2569ad;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
}
.log-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 557px;
}

.white-log-modal .ant-modal-content,
.white-payment-modal .ant-modal-content {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 100px !important;
}
.white-payment-modal .ant-modal-content {
  padding: 60px 100px !important;
}
.white-payment-modal .head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.ant-modal-body {
  width: fit-content !important;
}

.white-log-modal .ant-modal-body,
.white-payment-modal .ant-modal-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 557px;
}
.ant-modal {
  width: fit-content !important;
}
.white-log-modal .btn-primary,
.white-payment-modal .btn-primary {
  padding: 10px;
  max-width: 178px;
  margin: 0px auto;
}
.card-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cardbtn-primary {
  background: #2569ad;
  color: #fff;
  border-radius: 20px;
  width: 140px;
  font-size: 14px;
  line-height: normal;
  border: none;
  height: 40px;
  margin: auto;
  margin-top: 20px;
}
.btn-primary {
  background: #2569ad;
  color: #fff;
  border-radius: 20px;
  width: 100%;
  font-size: 14px;
  line-height: normal;
  border: none;
}
.input-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100% !important;
}
.input-wrap label {
  color: #2569ad;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}
textarea {
  padding: 12px;
  background: #fff;
  border: 1px solid #aeaeb2;
  border-radius: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  outline: none;
  min-height: 120px;
}
.input-wrap .input-div {
  padding: 12px;
  background: #fff;
  border: 1px solid #aeaeb2;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
}
input {
  color: #000;
  font-size: 14px;
  font-weight: 400;
  outline: none;
  border: none;
  width: 100%;
  max-width: 100% !important;
}
input::placeholder,
textarea::placeholder {
  color: #aeaeb2;
}

.white-call-modal .ant-modal-content {
  background: #2569ad;
  border-radius: 30px;
  padding: 90px 64px !important;
}
.white-call-modal .ant-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}
h5 {
  font-size: 36px;
  line-height: normal;
  text-align: center;
}
.white-call-modal h5 {
  color: #fff;
  font-weight: 500;
}
.white-payment-modal h5 {
  color: #2569ad;
  font-weight: 500;
}
.white-payment-modal h6 {
  color: black;
  font-size: 30px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}
.white-payment-modal .grid-div {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.white-call-modal p {
  color: #aeaeb2;
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}
.white-call-modal .userImg {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  object-fit: cover;
  max-width: 176.46px;
  max-height: 173px;
}
.white-call-modal .icons {
  max-width: 278px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 100px;
}
.white-call-modal .icons img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  filter: drop-shadow(0px 5px 7px rgba(0, 0, 0, 0.25));
}
.white-call-modal .ant-modal-close,
.review-modal .ant-modal-close {
  color: #fff;
}

.review-modal .ant-modal-content {
  background: #2569ad;
  border-radius: 30px;
  padding: 60px 30px 30px 30px !important;
}
.review-modal .ant-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  min-width: 408px;
}
.review-modal .top-sec {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.review-modal .small {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}
.review-modal p {
  color: #fff;
  font-weight: 500;
  font-size: 18px;
}
.review-modal .review-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 18px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
}
.review-modal .buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
}
.agent-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  margin-bottom: 60px;
}
.btn-secondary-main {
  background: #fff;
  color: #2569ad;
  width: fit-content;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  border-radius: 10px;
  border: none;
  padding: 10px;
}
.review-modal .btn-secondary {
  background: #fff;
  color: #2569ad;
  width: fit-content;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  border: none;
  padding: 10px;
}
.review-modal .btn-primary {
  background: #2569ad;
  color: #fff;
  max-width: 150px;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  padding: 12px;
}
.text-red {
  margin-top: -7px;
  color: #ff0000;
}
.CardField-number input {
  padding: 12px !important;
  background: var(--white) !important;
  border: 1px solid var(--gray) !important;
  border-radius: 10px !important;
  max-width: 100% !important;
}

@media screen and (max-width: 1024px) {
  .review-modal .ant-modal-body {
    gap: 16px;
    min-width: 408px;
  }

  .white-log-modal .ant-modal-body,
  .white-payment-modal .ant-modal-body,
  .log-form {
    gap: 16px;
    min-width: 360px;
  }
  .white-log-modal .ant-modal-content,
  .white-payment-modal .ant-modal-content {
    padding: 40px 20px 20px 20px !important;
  }
  .white-call-modal .ant-modal-body {
    gap: 16px;
  }

  .white-payment-modal .grid-div {
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
  }
  .white-call-modal .ant-modal-content {
    background: #2569ad;
    border-radius: 20px;
    padding: 40px !important;
  }

  h5 {
    font-size: 20px;
  }
  .white-payment-modal h6 {
    font-size: 18px;
  }
  .white-call-modal p {
    font-size: 16px;
  }
  .white-call-modal .userImg {
    max-width: 120px;
    max-height: 120px;
  }
  .white-call-modal .icons {
    max-width: 250px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 40px;
  }
  .white-call-modal .icons img {
    width: 40px;
    height: 40px;
    object-fit: contain;
    filter: drop-shadow(0px 5px 7px rgba(0, 0, 0, 0.25));
  }

  .review-modal .ant-modal-content {
    border-radius: 20px;
    padding: 40px 20px 20px 20px !important;
  }
  .review-modal .ant-modal-body {
    gap: 16px;
    min-width: 300px;
  }
  .review-modal .top-sec {
    gap: 4px;
  }
  .review-modal .small {
    font-size: 14px;
  }
  .review-modal p {
    font-size: 16px;
  }
  .review-modal .review-form {
    gap: 10px;
    padding: 10px;
  }
  .review-modal .buttons {
    gap: 20px;
  }

  .review-modal .btn-secondary {
    padding: 8px;
  }
  .review-modal .btn-primary {
    max-width: 100px;
    font-size: 12px;
    padding: 10px;
  }
  .input-wrap label {
    font-size: 12px;
  }
  textarea {
    padding: 8px;
    font-size: 12px;
    min-height: 80px;
  }
  .input-wrap .input-div {
    padding: 8px;
  }
  .input-wrap .input-div img {
    width: 20px;
    height: 20px;
  }
  input {
    font-size: 12px;
  }
  .input-wrap .stars-div img {
    width: 20px;
    height: 20px;
  }
  .widget {
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
  }
}

/*  */
@media screen and (max-width: 600px) {
  .white-log-modal .ant-modal-body,
  .white-payment-modal .ant-modal-body,
  .log-form {
    gap: 16px;
    min-width: 270px !important;
  }
}
.react-tel-input {
  .form-control {
    border-radius: 4.615px !important;
    background: #fff !important;
    border: 1px solid #aeaeb2 !important;
    height: 45px !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 48px !important;
    padding: 12px !important;
    padding-left: 50px !important;
    width: 100% !important;
    color: #000 !important;
    font-family: Inter !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    &::placeholder {
      color: #9aa3b0 !important;
    }
  }
  &:focus-visible {
    outline: 1px solid var(--orange-color) !important;
    border-radius: 4.615px !important;
  }
  &:focus {
    outline: 1px solid var(--orange-color) !important;
    border-radius: 4.615px !important;
  }
  &:focus-within {
    outline: 1px solid var(--orange-color) !important;
    border-radius: 4.615px !important;
  }
  .selected-flag {
    width: 38px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA,eAAe;;AAEf;EACE,+CAA+C;EAC/C,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,0BAA0B;AAC5B;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;AACtD;AACA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,wCAAwC;EACxC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;;;IAGE,SAAS;IACT,gBAAgB;EAClB;EACA;;IAEE,uCAAuC;EACzC;EACA;IACE,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oDAAoD;EACtD;;EAEA;IACE,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,aAAa;EACf;EACA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF;;AAEA,KAAK;AACL;EACE;;;IAGE,SAAS;IACT,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,iCAAiC;IACjC,2BAA2B;IAC3B,oCAAoC;IACpC,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,6BAA6B;IAC7B,wBAAwB;IACxB,6BAA6B;IAC7B,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,iDAAiD;IACjD,iCAAiC;EACnC;EACA;IACE,iDAAiD;IACjD,iCAAiC;EACnC;EACA;IACE,iDAAiD;IACjD,iCAAiC;EACnC;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n.white-label {\n  font-family: \"Poppins\", sans-serif;\n  margin: 0;\n  padding: 0;\n}\n.white-label .payment {\n  /* width: 250px; */\n  /* height: 40px; */\n}\n\n.widget {\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n  z-index: 99;\n  border-radius: 100%;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/* Ant design */\n\n.ant-modal-mask {\n  background: rgba(237, 237, 237, 0.5) !important;\n  backdrop-filter: blur(20.299999237060547px) !important;\n}\n.card-input {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.card-label {\n  color: #2569ad;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: normal;\n  text-align: center;\n}\n.log-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 557px;\n}\n\n.white-log-modal .ant-modal-content,\n.white-payment-modal .ant-modal-content {\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25);\n  padding: 100px !important;\n}\n.white-payment-modal .ant-modal-content {\n  padding: 60px 100px !important;\n}\n.white-payment-modal .head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n.ant-modal-body {\n  width: fit-content !important;\n}\n\n.white-log-modal .ant-modal-body,\n.white-payment-modal .ant-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 557px;\n}\n.ant-modal {\n  width: fit-content !important;\n}\n.white-log-modal .btn-primary,\n.white-payment-modal .btn-primary {\n  padding: 10px;\n  max-width: 178px;\n  margin: 0px auto;\n}\n.card-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.cardbtn-primary {\n  background: #2569ad;\n  color: #fff;\n  border-radius: 20px;\n  width: 140px;\n  font-size: 14px;\n  line-height: normal;\n  border: none;\n  height: 40px;\n  margin: auto;\n  margin-top: 20px;\n}\n.btn-primary {\n  background: #2569ad;\n  color: #fff;\n  border-radius: 20px;\n  width: 100%;\n  font-size: 14px;\n  line-height: normal;\n  border: none;\n}\n.input-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 100% !important;\n}\n.input-wrap label {\n  color: #2569ad;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: normal;\n}\ntextarea {\n  padding: 12px;\n  background: #fff;\n  border: 1px solid #aeaeb2;\n  border-radius: 10px;\n  color: #000;\n  font-size: 14px;\n  font-weight: 400;\n  outline: none;\n  min-height: 120px;\n}\n.input-wrap .input-div {\n  padding: 12px;\n  background: #fff;\n  border: 1px solid #aeaeb2;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\ninput {\n  color: #000;\n  font-size: 14px;\n  font-weight: 400;\n  outline: none;\n  border: none;\n  width: 100%;\n  max-width: 100% !important;\n}\ninput::placeholder,\ntextarea::placeholder {\n  color: #aeaeb2;\n}\n\n.white-call-modal .ant-modal-content {\n  background: #2569ad;\n  border-radius: 30px;\n  padding: 90px 64px !important;\n}\n.white-call-modal .ant-modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n}\nh5 {\n  font-size: 36px;\n  line-height: normal;\n  text-align: center;\n}\n.white-call-modal h5 {\n  color: #fff;\n  font-weight: 500;\n}\n.white-payment-modal h5 {\n  color: #2569ad;\n  font-weight: 500;\n}\n.white-payment-modal h6 {\n  color: black;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n}\n.white-payment-modal .grid-div {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.white-call-modal p {\n  color: #aeaeb2;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n}\n.white-call-modal .userImg {\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  object-fit: cover;\n  max-width: 176.46px;\n  max-height: 173px;\n}\n.white-call-modal .icons {\n  max-width: 278px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin-top: 100px;\n}\n.white-call-modal .icons img {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  filter: drop-shadow(0px 5px 7px rgba(0, 0, 0, 0.25));\n}\n.white-call-modal .ant-modal-close,\n.review-modal .ant-modal-close {\n  color: #fff;\n}\n\n.review-modal .ant-modal-content {\n  background: #2569ad;\n  border-radius: 30px;\n  padding: 60px 30px 30px 30px !important;\n}\n.review-modal .ant-modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  min-width: 408px;\n}\n.review-modal .top-sec {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.review-modal .small {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n}\n.review-modal p {\n  color: #fff;\n  font-weight: 500;\n  font-size: 18px;\n}\n.review-modal .review-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 10px 18px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  width: 100%;\n}\n.review-modal .buttons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n}\n.agent-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 60px;\n}\n.btn-secondary-main {\n  background: #fff;\n  color: #2569ad;\n  width: fit-content;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: normal;\n  border-radius: 10px;\n  border: none;\n  padding: 10px;\n}\n.review-modal .btn-secondary {\n  background: #fff;\n  color: #2569ad;\n  width: fit-content;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: normal;\n  border: none;\n  padding: 10px;\n}\n.review-modal .btn-primary {\n  background: #2569ad;\n  color: #fff;\n  max-width: 150px;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.4);\n  border-radius: 8px;\n  padding: 12px;\n}\n.text-red {\n  margin-top: -7px;\n  color: #ff0000;\n}\n.CardField-number input {\n  padding: 12px !important;\n  background: var(--white) !important;\n  border: 1px solid var(--gray) !important;\n  border-radius: 10px !important;\n  max-width: 100% !important;\n}\n\n@media screen and (max-width: 1024px) {\n  .review-modal .ant-modal-body {\n    gap: 16px;\n    min-width: 408px;\n  }\n\n  .white-log-modal .ant-modal-body,\n  .white-payment-modal .ant-modal-body,\n  .log-form {\n    gap: 16px;\n    min-width: 360px;\n  }\n  .white-log-modal .ant-modal-content,\n  .white-payment-modal .ant-modal-content {\n    padding: 40px 20px 20px 20px !important;\n  }\n  .white-call-modal .ant-modal-body {\n    gap: 16px;\n  }\n\n  .white-payment-modal .grid-div {\n    grid-template-columns: repeat(1, 1fr);\n    gap: 16px;\n  }\n  .white-call-modal .ant-modal-content {\n    background: #2569ad;\n    border-radius: 20px;\n    padding: 40px !important;\n  }\n\n  h5 {\n    font-size: 20px;\n  }\n  .white-payment-modal h6 {\n    font-size: 18px;\n  }\n  .white-call-modal p {\n    font-size: 16px;\n  }\n  .white-call-modal .userImg {\n    max-width: 120px;\n    max-height: 120px;\n  }\n  .white-call-modal .icons {\n    max-width: 250px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-top: 40px;\n  }\n  .white-call-modal .icons img {\n    width: 40px;\n    height: 40px;\n    object-fit: contain;\n    filter: drop-shadow(0px 5px 7px rgba(0, 0, 0, 0.25));\n  }\n\n  .review-modal .ant-modal-content {\n    border-radius: 20px;\n    padding: 40px 20px 20px 20px !important;\n  }\n  .review-modal .ant-modal-body {\n    gap: 16px;\n    min-width: 300px;\n  }\n  .review-modal .top-sec {\n    gap: 4px;\n  }\n  .review-modal .small {\n    font-size: 14px;\n  }\n  .review-modal p {\n    font-size: 16px;\n  }\n  .review-modal .review-form {\n    gap: 10px;\n    padding: 10px;\n  }\n  .review-modal .buttons {\n    gap: 20px;\n  }\n\n  .review-modal .btn-secondary {\n    padding: 8px;\n  }\n  .review-modal .btn-primary {\n    max-width: 100px;\n    font-size: 12px;\n    padding: 10px;\n  }\n  .input-wrap label {\n    font-size: 12px;\n  }\n  textarea {\n    padding: 8px;\n    font-size: 12px;\n    min-height: 80px;\n  }\n  .input-wrap .input-div {\n    padding: 8px;\n  }\n  .input-wrap .input-div img {\n    width: 20px;\n    height: 20px;\n  }\n  input {\n    font-size: 12px;\n  }\n  .input-wrap .stars-div img {\n    width: 20px;\n    height: 20px;\n  }\n  .widget {\n    bottom: 20px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n  }\n}\n\n/*  */\n@media screen and (max-width: 600px) {\n  .white-log-modal .ant-modal-body,\n  .white-payment-modal .ant-modal-body,\n  .log-form {\n    gap: 16px;\n    min-width: 270px !important;\n  }\n}\n.react-tel-input {\n  .form-control {\n    border-radius: 4.615px !important;\n    background: #fff !important;\n    border: 1px solid #aeaeb2 !important;\n    height: 45px !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    padding-left: 48px !important;\n    padding: 12px !important;\n    padding-left: 50px !important;\n    width: 100% !important;\n    color: #000 !important;\n    font-family: Inter !important;\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    &::placeholder {\n      color: #9aa3b0 !important;\n    }\n  }\n  &:focus-visible {\n    outline: 1px solid var(--orange-color) !important;\n    border-radius: 4.615px !important;\n  }\n  &:focus {\n    outline: 1px solid var(--orange-color) !important;\n    border-radius: 4.615px !important;\n  }\n  &:focus-within {\n    outline: 1px solid var(--orange-color) !important;\n    border-radius: 4.615px !important;\n  }\n  .selected-flag {\n    width: 38px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
